/* This is generated code, don't alter */
var IfcLampTypeEnum;
(function (IfcLampTypeEnum) {
    IfcLampTypeEnum[IfcLampTypeEnum["COMPACTFLUORESCENT"] = 0] = "COMPACTFLUORESCENT";
    IfcLampTypeEnum[IfcLampTypeEnum["FLUORESCENT"] = 1] = "FLUORESCENT";
    IfcLampTypeEnum[IfcLampTypeEnum["HALOGEN"] = 2] = "HALOGEN";
    IfcLampTypeEnum[IfcLampTypeEnum["HIGHPRESSUREMERCURY"] = 3] = "HIGHPRESSUREMERCURY";
    IfcLampTypeEnum[IfcLampTypeEnum["HIGHPRESSURESODIUM"] = 4] = "HIGHPRESSURESODIUM";
    IfcLampTypeEnum[IfcLampTypeEnum["LED"] = 5] = "LED";
    IfcLampTypeEnum[IfcLampTypeEnum["METALHALIDE"] = 6] = "METALHALIDE";
    IfcLampTypeEnum[IfcLampTypeEnum["OLED"] = 7] = "OLED";
    IfcLampTypeEnum[IfcLampTypeEnum["TUNGSTENFILAMENT"] = 8] = "TUNGSTENFILAMENT";
    IfcLampTypeEnum[IfcLampTypeEnum["USERDEFINED"] = 9] = "USERDEFINED";
    IfcLampTypeEnum[IfcLampTypeEnum["NOTDEFINED"] = 10] = "NOTDEFINED";
})(IfcLampTypeEnum || (IfcLampTypeEnum = {}));
const IfcLampTypeEnumCount = 11;
export { IfcLampTypeEnum, IfcLampTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcLampTypeEnum = new Int32Array([-4, 3, 471]);
let prefixSumAddressIfcLampTypeEnum = new Uint32Array([0, 13, 33, 45, 66, 79, 92, 112, 117, 135, 141, 150]);
let slotMapIfcLampTypeEnum = new Int32Array([6, 0, 10, 3, 9, 1, 4, 5, 8, 7, 2]);
let encodedDataIfcLampTypeEnum = (new TextEncoder()).encode(".METALHALIDE..COMPACTFLUORESCENT..NOTDEFINED..HIGHPRESSUREMERCURY..USERDEFINED..FLUORESCENT..HIGHPRESSURESODIUM..LED..TUNGSTENFILAMENT..OLED..HALOGEN.");
let IfcLampTypeEnumSearch = new MinimalPerfectHash(gMapIfcLampTypeEnum, prefixSumAddressIfcLampTypeEnum, slotMapIfcLampTypeEnum, encodedDataIfcLampTypeEnum);
export { IfcLampTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcLampTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcLampTypeEnumSearch, input, cursor, endCursor);
}
